import {takeLatest, put, call} from 'redux-saga/effects'
import {SEND_VERIFY_EMAIL} from 'actions/verifyEmail/constants'
import {postVerifyEmail} from 'api/verifyEmail'
import * as act from 'actions/index'
import {browserHistory} from 'react-router'
import {isInvalidTokenVerifyEmail} from 'actions/verifyEmail'

export function * verifyEmail (request) {
  yield put(act.showLoadingSpinner(true))
  try {
    let token = request.payload.access_token
    let resVerifyEmail = yield call(postVerifyEmail, {access_token: token})
    let user = resVerifyEmail.data
    if (user) {
      yield put(act.setAuthState(true, user))
      if (user.is_owner || user.is_manager) {
        // owner or manager go to dashboard page
        browserHistory.push('/dashboard')
      } else {
        // staff go to account settings
        browserHistory.push('/settings/accounts')
      }
    }
  } catch (error) {
    yield put(isInvalidTokenVerifyEmail(true))
  } finally {
    yield put(act.showLoadingSpinner(false))
  }
}

export default function * verifyEmailSaga () {
  yield takeLatest(SEND_VERIFY_EMAIL, verifyEmail)
}



// WEBPACK FOOTER //
// ./app/sagas/verifyEmail/index.js